import React from "react";
import { Fade } from "react-awesome-reveal";

const certifications = [
  {
    name: "DPIIT Startup India",
    image: "https://www.startupindia.gov.in/sih/themes/custom/startup_india/images/header-icons/DPIIT-header.png",
  },
  {
    name: "Microsoft Partner",
    image: "https://konverge.ai/wp-content/uploads/2024/08/microsoft.webp",
  },
  {
    name: "Google Cloud Partner",
    image: "https://images.ctfassets.net/76f8cs5bg9si/2qLBwIOSayngsemIU1r9Ip/a2ab1788f2f6732b763b78cb3a7ccafb/Google_Cloud.png?w=600&h=200&q=90&fm=png",
  }
];

const Certifications = () => {
  return (
    <section className="bg-gray-50 py-14 px-6 md:px-20 border-t-2">
      <div className="max-w-6xl mx-auto text-center">
        <Fade triggerOnce>
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-8">
            We Are Proudly Certified & Recognized By
          </h2>
        </Fade>

        <div className="flex flex-wrap justify-center items-center gap-10">
          {certifications.map((cert, index) => (
            <Fade key={index} triggerOnce delay={index * 100}>
              <div className="flex flex-col items-center gap-2">
                <img
                  src={cert.image}
                  alt={cert.name}
                  className="h-14 md:h-16 object-contain grayscale hover:grayscale-0 transition duration-300"
                />
                <p className="text-sm text-gray-600">{cert.name}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
